// Função para formatar data sem problemas de timezone
export const formatarData = (dataString) => {
  if (!dataString) return '';
  
  // Se já está no formato DD/MM/YYYY, retornar como está
  if (dataString.includes('/')) return dataString;
  
  // Se está no formato YYYY-MM-DD, converter para DD/MM/YYYY
  const partes = dataString.split('-');
  if (partes.length === 3) {
    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }
  
  // Tentar usar Date como fallback, adicionando hora do meio-dia para evitar problemas de timezone
  try {
    const data = new Date(dataString + 'T12:00:00');
    if (!isNaN(data.getTime())) {
      return data.toLocaleDateString('pt-BR');
    }
  } catch (e) {
    console.error('Erro ao formatar data:', e);
  }
  
  return dataString;
};

// Função para converter data do formato DD/MM/YYYY para YYYY-MM-DD (para inputs type="date")
export const dataParaInput = (dataString) => {
  if (!dataString) return '';
  
  // Se já está no formato YYYY-MM-DD, retornar como está
  if (dataString.includes('-') && dataString.length === 10) {
    return dataString;
  }
  
  // Se está no formato DD/MM/YYYY, converter para YYYY-MM-DD
  const partes = dataString.split('/');
  if (partes.length === 3) {
    return `${partes[2]}-${partes[1]}-${partes[0]}`;
  }
  
  return dataString;
};
